import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import swal from "sweetalert";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import { login } from "./../components/action/user";
import isEmpty from "./../lib/isEmpty";
import config from "./../lib/config";

const useStyles = makeStyles(() => ({
  InputLabel: {
    color: "rgb(0,0,0)",
    fontFamily: "Source Sans Pro",
  },
}));

const initialLoginFormValue = {
  logindate: "",
  loginmonth: "",
  loginyear: "",
  phonenumber: "",
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function Tabp() {
  const classes = useStyles();
  const history = useNavigate();

  const [value, setValue] = useState(0);
  const [loginFormValue, setLoginFormValue] = useState(initialLoginFormValue);
  const [otpSent, setOtpSent] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [loading, setLoading] = useState(false);

  const dayOption = Array.from({ length: 31 }, (_, i) => i + 1);
  const yearOption = Array.from({ length: 27 }, (_, i) => i + 1980);

  const { logindate, loginmonth, loginyear, phonenumber } = loginFormValue;

  const onChangelogin = (e) => {
    const { id, value } = e.target;
    setLoginFormValue({ ...loginFormValue, [id]: value });
  };

  /** Send OTP after checking user existence */
  const handleSendOtp = async (e) => {
    e.preventDefault();

    if (!phonenumber || !logindate || !loginmonth || !loginyear) {
      swal("Please fill all required fields.");
      return;
    }

    try {
      setLoading(true);

      let reqData = {
        dob: `${loginyear}-${loginmonth}-${logindate}`,
        date: logindate,
        month: loginmonth,
        year: loginyear,
        phone_number: phonenumber,
      };

      let { error, result } = await login(reqData);

      if (!isEmpty(error)) {
        setLoading(false);
        localStorage.removeItem("user_token");
        if (error.dob) {
          swal("Your account is not registered.");
        } else {
          swal("The details you have registered are not valid. Please call for more information-9652966888");
        }
        return;
      }

      const sendOtpRes = await fetch(`${config.API}/web/sendotp`, {
        method: "GET",
        headers: { Authorization: `${localStorage.getItem("user_token")}` },
        // credentials: 'include',
      });

      const sendOtpData = await sendOtpRes.json();
      // console.log('sendOtpData', sendOtpData)
      setLoading(false);

      if (!sendOtpRes.ok || !sendOtpData.success) {
        localStorage.removeItem("user_token");
        swal(sendOtpData.message || "Failed to send OTP.");
        return;
      }

      swal("OTP sent successfully!");
      setOtpSent(true);
    } catch (err) {
      setLoading(false);
      localStorage.removeItem("user_token");
      swal("Network error while sending OTP.");
      console.error(err);
    }
  };

  /** Verify OTP and login */
  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    if (!otpValue) {
      swal("Please enter OTP.");
      return;
    }

    try {
      setLoading(true);

      const verifyRes = await fetch(`${config.API}/web/verifyotp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("user_token")}`,
        },
        body: JSON.stringify({ otp: otpValue }),
      });

      const verifyData = await verifyRes.json();
      console.log('verify data', verifyData)
      setLoading(false);

      if (verifyRes.status === 401) {
        // token invalid or expired
        localStorage.removeItem("user_token");
        swal("Session expired. Please try again.");
        return;
      }

      if (!verifyRes.ok || !verifyData.success) {
        swal(verifyData.message || "Invalid OTP. Please try again.");
        return; // don't remove token, allow retry
      }

      swal("OTP verified! Logging in...");
      window.location = "/myprofile";
    } catch (err) {
      setLoading(false);
      swal("Network error during OTP verification.");
      console.error(err);
    }
  };


  const handleSubmit = (e) => {
    if (otpSent) {
      handleVerifyOtp(e);
    } else {
      handleSendOtp(e);
    }
  };

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="colorzz">
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }} className="tabss">
          <div style={{ textAlign: "center", backgroundColor: "#EDE8D0" }}>
            <Tab
              style={{ fontSize: "15px", fontWeight: "700" }}
              label="MEMBER LOGIN"
              {...{ id: `simple-tab-0`, "aria-controls": `simple-tabpanel-0` }}
            />
          </div>
        </Box>

        <TabPanel value={value} index={0}>
          <form noValidate onSubmit={handleSubmit}>
            <div className="form-group">
              <label style={{ fontSize: "16px", display: "block" }}>
                Date of Birth
              </label>
              <select
                id="logindate"
                value={logindate}
                onChange={onChangelogin}
                className="daaa"
              >
                <option value="">Date</option>
                {dayOption.map((date) => (
                  <option key={date} value={date}>
                    {date}
                  </option>
                ))}
              </select>
              <select
                id="loginmonth"
                value={loginmonth}
                onChange={onChangelogin}
                className="daaa"
              >
                <option value="">Month</option>
                {[
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ].map((month, index) => (
                  <option key={index + 1} value={index + 1}>
                    {month}
                  </option>
                ))}
              </select>
              <select
                id="loginyear"
                value={loginyear}
                onChange={onChangelogin}
                className="daaa"
              >
                <option value="">Year</option>
                {yearOption.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label style={{ fontSize: "16px" }}>
                Mobile Number <span className="reguired">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                onChange={onChangelogin}
                id="phonenumber"
                value={phonenumber}
                style={{ padding: "20px", fontSize: "16px", border: "1px solid #000000" }}
              />
            </div>

            {otpSent && (
              <div className="form-group">
                <label style={{ fontSize: "16px" }}>Enter OTP</label>
                <input
                  type="text"
                  className="form-control"
                  value={otpValue}
                  onChange={(e) => setOtpValue(e.target.value)}
                  style={{ padding: "20px", fontSize: "16px", border: "1px solid #000000" }}
                />
              </div>
            )}

            <button
              type="submit"
              className="btn send-otp"
              disabled={loading}
              style={{
                backgroundColor: "#BA3E3E",
                color: "white",
                fontSize: "16px",
                fontWeight: "bold",
                width: "100%",
              }}
            >
              {loading
                ? "Please wait..."
                : otpSent
                  ? "Verify OTP & Login"
                  : "Send OTP"}
            </button>
          </form>

          <div className="advanced-searc-lnk">
            <a style={{ fontSize: "15px" }} href="/registration">
              Are you new? Click here to register your horoscope.
            </a>
          </div>
        </TabPanel>
      </Box>
    </div>
  );
}
